import React from 'react';

export const DriveIcon = () => (
  <svg className="h-4 w-4 text-slate-400 mb-0.5" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="8" cy="8" r="3" /><circle cx="24" cy="8" r="3" /><line x1="11" y1="8" x2="21" y2="8" />
    <line x1="16" y1="8" x2="16" y2="24" />
    <circle cx="8" cy="24" r="3" /><circle cx="24" cy="24" r="3" /><line x1="11" y1="24" x2="21" y2="24" />
  </svg>
);

export const GearIcon = () => (
  <svg className="h-4 w-4 text-slate-400 mb-0.5" viewBox="0 0 32 32" fill="currentColor">
    <circle cx="10" cy="6" r="5" />
    <rect x="8" y="9" width="4" height="10" rx="1" transform="rotate(-20 10 14)" />
    <rect x="4" y="20" width="24" height="3" rx="1.5" /><rect x="6" y="24" width="20" height="3" rx="1.5" /><rect x="8" y="28" width="16" height="3" rx="1.5" />
  </svg>
);

export const SpeedIcon = () => (
  <svg className="h-4 w-4 text-slate-400 mb-0.5" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M6 22 A12 12 0 1 1 26 22" />
    <line x1="16" y1="6" x2="16" y2="9" /><line x1="8" y1="10" x2="10" y2="12" /><line x1="24" y1="10" x2="22" y2="12" />
    <line x1="5" y1="18" x2="8" y2="18" /><line x1="27" y1="18" x2="24" y2="18" />
    <line x1="16" y1="18" x2="22" y2="12" strokeWidth="2" /><circle cx="16" cy="18" r="2" fill="currentColor" />
  </svg>
);

export const PlayIcon = ({ className = 'h-3 w-3' }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
);
